// extracted by mini-css-extract-plugin
module.exports = {"title":"_8af72b6e f2 fw6 tab_content b--black-10 lh-solid black mv0 pb3 tracked-tight truncate mb3-l"};